<template>
  <div
    class="plc-field"
    :class="[
      { 'plc-field--active': isActive },
      { 'plc-field--error': isError },
      { 'plc-field--success': isSuccess },
      { 'plc-field--disabled': disabled },
      { 'plc-field--row': isDirectionRow },
      { 'plc-field--border': withBorder },
      { 'plc-field--short': isShort },
    ]"
  >
    <label v-if="label" :for="innerId" class="plc-field__label">
      <span v-html="label" /><span v-if="required">&nbsp;*</span>
    </label>

    <div v-if="!isSwitcher" class="plc-field__fieldWrap">
      <div class="plc-field__field">
        <slot :innerId="innerId" />
        <slot name="icon" />
        <!--        <span class="plc-field__border"-->
        <!--          ><span class="plc-field__sideBorder"></span-->
        <!--        ></span>-->
        <gl-svg-icon
          v-if="error"
          icon="alert"
          class="plc-field__icon"
          :class="{ 'plc-field__icon--shift': withVendorIcon || $slots.icon }"
        />
        <gl-svg-icon
          v-if="isSuccess"
          icon="check"
          class="plc-field__icon"
          :class="{ 'plc-field__icon--shift': withVendorIcon || $slots.icon }"
        />
      </div>
      <slot name="symbol" />
    </div>
    <!--for switcher-->
    <slot v-else />

    <div v-if="$slots['below-field']" class="plc-field__belowField">
      <slot name="below-field" />
    </div>

    <transition name="fade">
      <p v-if="error" class="fieldErrorMsg">{{ error }}</p>
    </transition>
    <transition name="fadeInTip">
      <div v-if="isShowTip" class="plc-field__tip plc-fieldTip">
        <gl-svg-icon icon="info" class="plc-fieldTip__icon" />
        <p class="plc-fieldTip__text">{{ tip }}</p>
      </div>
    </transition>
  </div>
</template>

<script>
import { vueUidMixin } from 'vue-uid'
import GlSvgIcon from '@gl/GlSvgIcon'

export default {
  name: 'GlField',
  components: { GlSvgIcon },
  mixins: [vueUidMixin],
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number, Object],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    tip: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    disabled: Boolean,
    isActive: Boolean,
    required: Boolean,
    isDirectionRow: Boolean,
    isSwitcher: Boolean,
    withBorder: {
      type: Boolean,
      default: true,
    },
    withVendorIcon: Boolean,
    isShort: Boolean,
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      innerId: null,
      isSuccess: false,
    }
  },
  computed: {
    isError() {
      return !!this.error
    },
    isShowTip() {
      return this.isActive && this.tip
    },
  },
  created() {
    this.innerId = this.id || `input-${this.$_uid}`
  },
}
</script>

<style lang="scss">
@import '~styles/blocks/fieldErrorMsg';

.plc-field {
  $this: &;
  $transition-duration: 0.2s;

  --custom-border-width: 1px;

  &__label {
    @include text-subtitle-2;

    color: var(--state-color, rgba(0, 0, 0, 0.87));
    display: inline-flex;
    margin-bottom: 8px;
    transition: color 0.1s;
    vertical-align: top;
  }

  &__fieldWrap {
    display: flex;
  }

  &__field {
    @include text-body-1;

    flex-grow: 1;
    min-width: 0;
    position: relative;

    &:hover {
      --state-color: #{$color-primary};

      @at-root #{$this}--border {
        --custom-border-width: 2px;
      }
    }

    & + & {
      margin-left: 16px;
    }
  }

  &__input {
    @include placeholder(rgba(0, 0, 0, 0.38));
    @include scrollbar;
    @include text-body-1;

    border: 0;
    box-shadow: 0 0 0 500px $color-gray-6 inset; // for browser autofill
    display: block;
    margin: 0; // for safari
    outline: none;
    padding: 0;
    text-align: inherit;
    width: 100%;
  }

  &__symbol {
    @include text-subtitle-2;

    align-self: center;
    flex-shrink: 0;
    margin-left: 8px;
  }

  &__icon {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;

    &--shift {
      right: 24px;
    }
  }

  &__tip {
    margin-top: 8px;
    width: 100%;

    @media (min-width: $breakpoint-xl) {
      left: calc(100% + 16px);
      margin-top: 0;
      position: absolute;
      top: calc(24px + 4px); // height and margin-bottom of label
      z-index: 100;
    }
  }

  &__aboveField {
    margin-bottom: 8px;
    margin-top: 4px;
  }

  &__belowField {
    margin-top: 8px;
  }

  &--border {
    $input-paddind: 10px;

    #{$this}__label {
      margin-bottom: 4px;
    }

    //#{$this}__border {
    //  &::before,
    //  &::after {
    //    background-color: var(--state-color);
    //    content: '';
    //    height: var(--custom-border-width);
    //    position: absolute;
    //    transition: width $transition-duration;
    //    width: 0;
    //  }
    //
    //  &::before {
    //    left: 0;
    //    top: 0;
    //  }
    //
    //  &::after {
    //    bottom: 0;
    //    right: 0;
    //  }
    //}

    //#{$this}__sideBorder {
    //  &::before,
    //  &::after {
    //    background-color: var(--state-color, #{$color-primary});
    //    content: '';
    //    height: 0;
    //    position: absolute;
    //    transition: height $transition-duration + 0.1;
    //    width: var(--custom-border-width);
    //  }
    //
    //  &::before {
    //    left: 0;
    //    top: 0;
    //  }
    //
    //  &::after {
    //    bottom: 0;
    //    right: 0;
    //  }
    //}

    //#{$this}__field {
    //  &:hover {
    //    #{$this}__border {
    //      &::before,
    //      &::after {
    //        width: 100%;
    //      }
    //    }
    //
    //    #{$this}__sideBorder {
    //      &::before,
    //      &::after {
    //        height: 100%;
    //      }
    //    }
    //  }
    //}

    #{$this}__input,
    #{$this}__select,
    #{$this}__date {
      border: 2px solid var(--state-color, transparent);
      background: $color-gray-6;
      border-radius: $border-radius;
    }

    #{$this}__input,
    #{$this}__select {
      padding: $input-paddind;
    }

    #{$this}__icon {
      right: $input-paddind;
      top: $input-paddind + 1px;

      &--shift {
        right: $input-paddind + 24px; // 24px - icon size
      }
    }
  }

  &--row {
    align-items: baseline;
    display: flex;

    #{$this}__label {
      margin-bottom: 0;
      margin-right: 8px;
    }

    #{$this}__fieldWrap {
      min-width: 80px;
    }
  }

  &--active,
  &--success,
  &--error {
    --custom-border-width: 2px;

    //&#{$this}--border {
    //  #{$this}__border {
    //    &::before,
    //    &::after {
    //      width: 100%;
    //    }
    //  }
    //
    //  #{$this}__sideBorder {
    //    &::before,
    //    &::after {
    //      height: 100%;
    //    }
    //  }
    //}
  }

  &--active {
    &,
    #{$this}__field:hover {
      --state-color: #{$color-primary};
    }
  }

  &--success {
    --state-color: #{$color-green};

    #{$this}__icon {
      color: $color-green;
    }
  }

  &--error {
    --state-color: #{$color-red};

    #{$this}__icon {
      color: $color-red;
    }
  }

  &--disabled {
    cursor: default;
    pointer-events: none;

    #{$this}__label {
      color: rgba(0, 0, 0, 0.38);
    }

    #{$this}__input,
    #{$this}__select,
    #{$this}__date {
      background-color: $color-gray-6;
      box-shadow: 0 0 0 500px $color-gray-6 inset; // for browser autofill
      color: rgba(0, 0, 0, 0.38);
    }

    &#{$this}--border {
      //#{$this}__input,
      //#{$this}__select,
      //#{$this}__date {
      //  border-color: rgba(0, 0, 0, 0.15);
      //}

      //#{$this}__border,
      //#{$this}__sideBorder {
      //  &::before,
      //  &::after {
      //    content: none;
      //  }
      //}
    }
  }

  &--short {
    #{$this}__field {
      max-width: 168px;

      @media (min-width: $breakpoint-md) {
        max-width: 168px;
      }

      @media (min-width: 1200px) {
        max-width: 168px !important; // todo .contentPayout__formGroup .plc-field__field
      }
    }
  }
}
</style>

<style lang="scss">
.plc-fieldTip {
  align-items: flex-start;
  background-color: #fff;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.05);
  display: flex;
  padding: 16px;

  &__icon {
    color: rgba(0, 0, 0, 0.38);
    flex-shrink: 0;
    margin-right: 8px;
  }

  &__text {
    @include text-body-2;
  }
}

@keyframes fadeInTip {
  0% {
    opacity: 0;
    transform: translate3d(0, -50%, 0);
  }

  to {
    opacity: 1;
    transform: translate(0);
  }
}

@keyframes fadeInTipLeft {
  0% {
    opacity: 0;
    transform: translate3d(20%, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate(0);
  }
}

.fadeInTip {
  $animation-duration: 0.5s;

  &-enter-active {
    animation: fadeInTip $animation-duration;

    @media (min-width: $breakpoint-xl) {
      animation-name: fadeInTipLeft;
    }
  }

  &-leave-active {
    @media (min-width: $breakpoint-xl) {
      animation: fadeInTipLeft $animation-duration reverse;
    }
  }
}
</style>
